export const PAYBIS_STATUS_CHECK_INTERVAL = 5_000;
export const PAYBIS_REFETCH_QUOTE_DEBOUNCE = 750;
export const currencyTo = 'USDT-SEPOLIA';
